/**
 * @generated SignedSource<<316adb8d91f4b4413df3f4d49e66ab5e>>
 * @relayHash 4ff9aaaf0a17446292cb5bcf157ca63f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9293b3482731c86d63a262f87b08644097858ca089736b9c015c73d51827e8f9

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type ModifyPlaylistButtonsQuery$variables = {
  cloudId: string;
};
export type ModifyPlaylistButtonsQuery$data = {
  readonly confluence_getPlaylist: {
    readonly tracks: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly mainContent: {
          readonly history: {
            readonly createdBy: {
              readonly displayName: string | null | undefined;
              readonly profilePicture: {
                readonly path: string;
              } | null | undefined;
            } | null | undefined;
            readonly ownedBy: {
              readonly displayName: string | null | undefined;
              readonly profilePicture: {
                readonly path: string;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly id: string | null | undefined;
          readonly links: {
            readonly base: string | null | undefined;
            readonly webui: string | null | undefined;
          } | null | undefined;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly value: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly space: {
            readonly key: string | null | undefined;
          } | null | undefined;
          readonly status: string | null | undefined;
          readonly subType: string | null | undefined;
          readonly title: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly supportingContent: ReadonlyArray<{
          readonly ari: string | null | undefined;
          readonly links: {
            readonly base: string | null | undefined;
            readonly webui: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly type: ConfluenceTrackType;
      }>;
    };
  } | null | undefined;
};
export type ModifyPlaylistButtonsQuery = {
  response: ModifyPlaylistButtonsQuery$data;
  variables: ModifyPlaylistButtonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "kind": "ScalarField",
  "name": "status"
},
v6 = {
  "kind": "ScalarField",
  "name": "subType"
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v9 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "base"
    },
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v12 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\"])"
},
v13 = {
  "kind": "ScalarField",
  "name": "ari"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v8/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ModifyPlaylistButtonsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluencePlaylist",
        "kind": "LinkedField",
        "name": "confluence_getPlaylist",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePaginatedTracks",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceTrack",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "mainContent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v10/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "ownedBy",
                            "plural": false,
                            "selections": (v10/*: any*/)
                          }
                        ]
                      },
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "supportingContent",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModifyPlaylistButtonsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluencePlaylist",
        "kind": "LinkedField",
        "name": "confluence_getPlaylist",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePaginatedTracks",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceTrack",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "mainContent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v14/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "ownedBy",
                            "plural": false,
                            "selections": (v14/*: any*/)
                          }
                        ]
                      },
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "supportingContent",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v11/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9293b3482731c86d63a262f87b08644097858ca089736b9c015c73d51827e8f9",
    "metadata": {},
    "name": "ModifyPlaylistButtonsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a4b44bf820e6a02841e5bff2e755e4d2";

export default node;
